import React, { memo } from 'react';
import { FormSectionBlokProps } from '../FormSectionBlok.interface';
import { storyblokEditable } from 'gatsby-source-storyblok';
import FormSection from '../FormSection/FormSection';

export interface ConditionalFormSectionBlokProps extends FormSectionBlokProps {
  show_if_product_is_selected:
    | 'buying'
    | 'selling'
    | 'buying-and-selling'
    | 'remortgaging';
}

interface ConditionalFormSectionProps {
  blok: ConditionalFormSectionBlokProps;
}

const ConditionalFormSection: React.FC<ConditionalFormSectionProps> = ({
  blok,
}) => {
  const { heading, description, form_fields, sectionNumber, updateState } =
    blok;

  return (
    <div {...storyblokEditable(blok)}>
      <FormSection
        heading={heading}
        description={description}
        formFields={form_fields}
        sectionNumber={sectionNumber}
      />
    </div>
  );
};

export default memo(ConditionalFormSection);
